module.exports = __webpack_public_path__ + "static/pioneer-overview-3e3b785eae396bb20f0d9a79cf2544cd.png";